import { render, staticRenderFns } from "./viewOrgTree.vue?vue&type=template&id=5b71cb6f&scoped=true"
import script from "./viewOrgTree.vue?vue&type=script&lang=js"
export * from "./viewOrgTree.vue?vue&type=script&lang=js"
import style0 from "./viewOrgTree.vue?vue&type=style&index=0&id=5b71cb6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71cb6f",
  null
  
)

export default component.exports